import headerTop from "@/components/HeaderTop";
import {
  getMyProfile,
  putMyProfile,
  changePassword
} from "@/http/api/profile";
import {
  verifyCode
} from '@/http/api/utility';
import {
  validatePhone,
  isvalidUsername,
  validateEmail,
  validateCharacter
} from "@/utils/validate";
import {
  deepCopy
} from "@/utils/deepCopy";
import {
  getUserDetails,
} from "@/http/api/employe";

export default {
  components: {
    headerTop
  },
  computed: {
    hidePhoneNumber() {
      if (this.userInfo.phoneNumber) {
        var num = this.userInfo.phoneNumber;
        return num.substr(0, 3) + '****' + num.substr(num.length - 4, num.length - 1);
      }
    },
    headPost() {
      if (this.userInfo.post) {
        return (
          this.userInfo.organizationUnit +
          "-" +
          this.userInfo.post +
          "-" +
          this.userInfo.position
        );
      } else {
        return "--";
      }
    },
  },
  data() {
    const validatorPhoneNumber = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入手机号！"));
      } else {
        if (!validatePhone(value)) {
          callback(new Error("手机号输入不正确"));
        } else {
          callback();
        }
      }
    };
    const validatorEmail = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入邮箱！"));
      } else {
        if (!validateEmail(value)) {
          callback(new Error("邮箱输入不正确"));
        } else {
          callback();
        }
      }
    };
    const validatorRepetPsw = (rule, value, callback) => {
      if (this.editPswQuery.newPassword != this.editPswQuery.repetPsw) {
        callback(new Error("两次输入密码不一致"));
      } else {
        callback();
      }
    };
    const validatePswCharacter = (rule, value, callback) => {
      if (!isvalidUsername(value)) {
        callback(new Error("请输入新密码"));
        return;
      }
      if (value.length < 7) {
        callback(new Error("新密码至少为7位"));
        return;
      }
      if (!validateCharacter(value)) {
        callback(new Error("新密码至少包含一位除数字字母外的特殊字符"));
        return;
      }
      callback();
    };

    return {
      // userInfoDetail: {},//个人详细信息
      userInfo: {}, //个人信息
      headerText: "个人中心",
      isEditPhoneShow: false, //修改手机弹窗
      isEditEmailShow: false, //修改联系邮箱
      isEditMottoShow: false,//个性签名
      isUnbindEmailShow: false, //解绑邮箱
      isEditPswShow: false, //修改密码
      isAuthenticationShow: false, //身份验证
      //修改手机参数
      messageCodeText: "发送验证码",
      areaCodeOptions: [{
        value: '+86',
        label: '+86'
      }],
      editPhoneQuery: {
        areaCode: '+86',
        phoneNumber: '',
        code: ''
      },
      editPhoneRules: {
        phoneNumber: [{
          required: true,
          validator: validatorPhoneNumber,
          trigger: 'blur'
        },],
        code: [{
          required: true,
          message: '请输入验证码',
          trigger: 'blur'
        },]
      },
      //修改邮箱
      editEmailQuery: {
        email: ''
      },
      //个性签名修改
      editMottoQuery: {
        motto: ''
      },
      editEmailRules: {
        email: [{
          required: true,
          validator: validatorEmail,
          trigger: 'blur'
        },]
      },
      //修改密码
      editPswQuery: {
        currentPassword: '',
        newPassword: '',
        repetPsw: '',
        code: ''
      },
      editPswRules: {
        currentPassword: [{
          required: true,
          message: '请输入原始密码',
          trigger: 'blur'
        }],
        newPassword: [{
          min: 9,
          required: true,
          validator: validatePswCharacter,
          trigger: 'blur'
        }],
        repetPsw: [{
          min: 9,
          required: true,
          validator: validatorRepetPsw,
          trigger: 'blur'
        }],
        // code: [{
        //   required: true,
        //   message: '请输入验证码',
        //   trigger: 'blur'
        // }]
      }
    };
  },
  methods: {
    // 获取员工信息
    // getUserInfo() {
    //   var id = this.$store.getters.sub;
    //   getUserDetails(id).then((res) => {
    //     //console.log(res);
    //     this.userInfoDetail = res.result;
    //   });
    // },
    //解绑邮箱
    unbindEmail() {
      this.$confirm("即将解绑邮箱, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.putMyProfileEmail('unbind')
        })
        .catch(() => {
          this.$message({
            message: "已取消",
            type: "info",
            showClose: true
          });
        });
    },
    //修改联系手机
    sendCode(phoneNumber) {
      if (!phoneNumber) {
        this.$message({
          message: '请输入手机号',
          type: 'warning',
          showClose: true
        });
        return;
      }
      if (!validatePhone(phoneNumber)) {
        this.$message({
          message: '请输入正确的手机号',
          type: 'warning',
          showClose: true
        });
        return;
      }
      this.time = 120;
      this.timer();
      this.$store
        .dispatch("GetCode", phoneNumber)
        .then(res => {
          this.$message({
            message: '验证码发送成功!',
            type: 'success',
            showClose: true
          });
          //console.log("验证码发送", res);
        })
        .catch(err => {
          //console.log(err);
        });
    },
    timer() {
      if (this.time > 0) {
        this.time--;
        this.messageCodeText = this.time + "s后重新获取";
        setTimeout(this.timer, 1000);
      } else {
        this.time = 0;
        this.messageCodeText = "发送验证码";
      }
    },
    editPhone(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.verifyCode(this.editPhoneQuery.phoneNumber, this.editPhoneQuery.code).then(res => {
            if (res) {
              this.putMyProfilePhone();
            } else {
              this.$message.error({
                message: '验证码错误',
                showClose: true
              });
            }
          });
        } else {
          
          return false;
        }
      });
    },
    //修改联系邮箱
    editEmail(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.putMyProfileEmail();
        } else {
          
          return false;
        }
      });
    },
    //修改密码
    closePassWord(){
      this.editPswQuery = {
        currentPassword: '',
        newPassword: '',
        repetPsw: '',
        code: ''
      }
    },
    changePswSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.verifyCode(this.userInfo.phoneNumber, this.editPswQuery.code).then(res => {
          //   if (res) {
          //     this.changePassword();
          //   } else {
          //     this.$message.error({
          //       message: '验证码错误',
          //       showClose: true
          //     });
          //   }
          // });
          this.changePassword();
        } else {
          
          return false;
        }
      });
    },
    //请求
    // 获取个人信息
    getMyProfile() {
      getMyProfile().then(res => {
        //console.log(res);
        this.userInfo = res.result;
      })
    },
    // 验证验证码
    verifyCode(phone, code) {
      return new Promise((resolve, reject) => {
        verifyCode(phone, code).then(res => {
          //console.log("验证验证码：", res);
          resolve(res.result);
        })
      })
    },
    //修改手机
    putMyProfilePhone() {
      var query = deepCopy(this.userInfo);
      query.phoneNumber = this.editPhoneQuery.phoneNumber;
      query.userName=this.editPhoneQuery.phoneNumber;

      putMyProfile(query).then(res => {
        //console.log('修改手机:', res);
        this.$message({
          message: '修改联系手机成功!',
          type: 'success',
          showClose: true
        });
        this.userInfo = res.result;
        this.isEditPhoneShow = false;
        this.$refs['editPhoneQuery'].resetFields();
      })
    },
    editMottoShow(){
      this.editMottoQuery.motto = this.userInfo.motto
      this.isEditMottoShow = true;
    },
    //修改个性签名
    editMotto() {
      var query = deepCopy(this.userInfo);
      query.motto = this.editMottoQuery.motto;
      putMyProfile(query).then(res => {
        this.$message({
          message: '修改个人签名成功!',
          type: 'success',
          showClose: true
        });

        this.userInfo = res.result;
        this.isEditMottoShow = false;
      })
    },
    //修改邮箱
    putMyProfileEmail(v) {
      var query = deepCopy(this.userInfo);
      query.email = this.editEmailQuery.email;
      if (v == 'unbind') {
        query.email = '';
      }
      putMyProfile(query).then(res => {
        //console.log('修改邮箱:', res);
        if (v == 'unbind') {
          // this.$message({
          //   message: '解绑联系邮箱成功!',
          //   type: 'success',
          //   showClose: true
          // });
          this.isUnbindEmailShow = true;
        } else {
          this.$message({
            message: '修改联系邮箱成功!',
            type: 'success',
            showClose: true
          });
          this.$refs['editEmailQuery'].resetFields();
        }
        this.userInfo = res.result;
        this.isEditEmailShow = false;
      })
    },
    //修改密码
    changePassword() {
      var query = this.editPswQuery;
      changePassword(query).then(res => {
        //console.log('修改密码:', res);
        this.$message({
          message: '修改密码成功!',
          type: 'success',
          showClose: true
        });
        this.isEditPswShow = false;
        this.$refs['editPswQuery'].resetFields();
      })
    },
  },
  created() {
    this.getMyProfile();
    // this.getUserInfo();
  }
};